import type { ComponentPropsWithoutRef, CSSProperties } from 'react';
import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './ImageWrapper.module.css';

const BORDER_RADIUS_VARS = {
  4: 'var(--radii-4)',
  8: 'var(--radii-8)',
} as const;

type ImageWrapperProps = ComponentPropsWithoutRef<'div'> & {
  borderRadius?: 4 | 8;
  hasBorder?: boolean;
  isCompact?: boolean;
};

export const ImageWrapper = forwardRef<HTMLDivElement, ImageWrapperProps>(
  (
    {
      borderRadius = 8,
      hasBorder = true,
      isCompact = false,
      className,
      style,
      ...props
    },
    ref
  ) => (
    <div
      ref={ref}
      className={clsx(
        styles.imageWrapper,
        className,
        isCompact && styles.isCompact
      )}
      style={
        {
          ...style,
          '--image-wrapper-border-radius': BORDER_RADIUS_VARS[borderRadius],
          '--image-wrapper-outline': hasBorder
            ? `${
                isCompact ? '0.5px' : '1px'
              } solid var(--colors-border-secondary)`
            : 'none',
        } as CSSProperties
      }
      {...props}
    />
  )
);

ImageWrapper.displayName = 'ImageWrapper';
